import { useContext } from 'react';

import { Color } from '../../Enum/Color';
import { FaxInfoDTOInterface } from '../../Interface/Hook/FaxInfo/FaxInfoDTOInterface';
import { Result } from '../../Interface/Response/Validator/Result';
import ResultContext from '../../Context/ResultContext';

const getColor = (value: boolean | null | undefined): Color => {
    if (value === null || value === undefined) {
        return Color.Orange;
    }
    return value ? Color.Green : Color.Red;
};

const getDifference = (loan: string | null, suppliedIncome: string | null): string | null => {
    if (loan === null || suppliedIncome === null) {
        return null;
    }

    const difference = Math.abs(parseFloat(suppliedIncome) - parseFloat(loan));

    if (difference === 0) {
        return null;
    }

    return `${difference}.00`;
};

const useGetFaxInfo = (): FaxInfoDTOInterface | null => {
    const result = useContext<Result | null>(ResultContext);

    if (!result) {
        return null;
    }

    if (result.faxInfo === undefined) {
        return {
            lening: null,
            lti: null,
            ltiVoldoet: Color.Orange,
            ltiIndicatie: null,
            ltv: null,
            ltvVoldoet: Color.Orange,
            ltvIndicatie: null,
        };
    }

    const lening = result.faxInfo.lening ?? null;
    const lti = result.faxInfo.lti ?? null;
    const ltv = result.faxInfo.ltv ?? null;

    return {
        lening,
        lti,
        ltiVoldoet: getColor(result.faxInfo.ltiVoldoet),
        ltiIndicatie: getDifference(lening, lti),
        ltv,
        ltvVoldoet: getColor(result.faxInfo.ltvVoldoet),
        ltvIndicatie: getDifference(lening, ltv),
    };
};

export default useGetFaxInfo;
